module.exports = __webpack_public_path__ + "img/44cbfb1631a0a61a09ec6a16a8d0c6fe.jpg";